module.exports = __webpack_public_path__ + "static/verein-intro-img-ceca1da8df096f381956d990281828ae.png";